<template>
  <div>
    <!-- Список товаров категории -->
    <div itemscope itemtype="http://schema.org/ItemList">
      <meta :content="props.categoryName || ''" itemprop="name">
      <meta :content="props.description || ''" itemprop="description">
      <meta :content="String(props.countProducts || 0)" itemprop="numberOfItems">
      <template v-if="imagePath">
        <meta :content="imagePath" itemprop="image">
      </template>
    </div>

    <!-- Агрегированная информация о предложениях -->
    <div itemscope itemtype="http://schema.org/AggregateOffer">
      <meta :content="String(props.countProducts || 0)" itemprop="offerCount">
      <meta :content="String(props.minPrice || 0)" itemprop="lowPrice">
      <template v-if="props.maxPrice">
        <meta :content="String(props.maxPrice)" itemprop="highPrice">
      </template>
      <meta content="RUB" itemprop="priceCurrency">
      <meta content="https://schema.org/InStock" itemprop="availability">
    </div>

    <!-- Рейтинг категории товаров -->
    <div itemscope itemtype="http://schema.org/AggregateRating">
      <meta itemprop="ratingValue" content="5.0">
      <meta itemprop="bestRating" content="5">
      <meta itemprop="worstRating" content="1">
      <meta :content="String(randomNumberRatingCount)" itemprop="ratingCount">
      <meta :content="String(randomNumberReviewsCount)" itemprop="reviewCount">
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  maxPrice?: number | null,
  minPrice?: number | null,
  imageId?: any,
  imagePath?: string,
  categoryName?: string,
  countProducts?: number,
  description?: string,
}>();
const $img = useImage();

const imagePath: ComputedRef<string> = computed(() => {
  if (!props.imageId) {
    return ''
  }
  return $img(String(props.imageId))
});

// Детерминированное значение на основе названия категории для избежания ошибок гидратации
const randomNumberReviewsCount: any = computed(() => {
  const categoryName = props.categoryName || String(props.countProducts || '0')
  // Простая хеш-функция для генерации детерминированного значения
  let hash = 0
  for (let i = 0; i < categoryName.length; i++) {
    hash = ((hash << 5) - hash) + categoryName.charCodeAt(i)
    hash = hash & hash // Convert to 32bit integer
  }
  const min = 200
  const max = 500
  return min + (Math.abs(hash) % (max - min + 1))
})
const randomNumberRatingCount: any = computed(() => {
  return randomNumberReviewsCount.value + 15
})
</script>

